import { render } from "./ViewMessage.vue?vue&type=template&id=7437da95"
import script from "./ViewMessage.vue?vue&type=script&lang=js"
export * from "./ViewMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__